export const sorts = {
  galleries: [
    { title: "Created", sort: "created" },
    { title: "Name", sort: "name" },
  ],
  artworks: [
    { title: "Title", sort: "title" },
    { title: "Created", sort: "created" },
  ],
  spaces: [
    { title: "Title", sort: "title" },
    { title: "Created", sort: "created" },
  ],
  exhibitions: [
    { title: "Created", sort: "created" },
    { title: "Title", sort: "title" },
  ],
}
